import { render, staticRenderFns } from "./DataModal.vue?vue&type=template&id=86815300&scoped=true"
import script from "./DataModal.vue?vue&type=script&lang=js"
export * from "./DataModal.vue?vue&type=script&lang=js"
import style0 from "./DataModal.vue?vue&type=style&index=0&id=86815300&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86815300",
  null
  
)

export default component.exports